import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        "text-h1",
        "text-h2",
        "text-h3",
        "text-h4",
        "text-h5",
        "text-h6",
        "text-h7",
        "text-headline",
        "text-bodySm",
        "text-bodyMd",
        "text-bodyLg",
        "text-h1-satoshi",
        "text-h2-satoshi",
        "text-h4-satoshi",
        "text-h6-satoshi",
        "text-h7-satoshi",
        "text-headline-satoshi",
        "text-menu",
      ],
    },
  },
});

/**
 * Combines clsx and tailwind-merge for conditional class merging
 * with Tailwind CSS class conflict resolution.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
